import { useContext, useState } from 'react';
import HeaderWrapper from './HeaderWrapper';
import FieldNameEditor from './FieldNameEditor';
import FieldName from './FieldName';
import FieldPositionMoving from './FieldPositionMoving';
import FieldActions from './FieldActions';
import type ContentGroupType from '@/lib/constants/challengeModel/ContentGroupType.enum';
import AdditionalConfigStateContext from '../AdditionalConfigStateContext';
import SaveAdditionalConfigChangesButton from './SaveAdditionalConfigChangesButton';
import EditorIsReadonlyContext from '@/pages/EditorPage/ChallengeModelsEditor/EditorIsReadonlyContext';

type FieldHeaderProps = {
  allHighestPositions: Record<ContentGroupType, number>;
  lowestFieldPositionInSectionBottomContent: number;
};

const FieldHeader = ({
  allHighestPositions,
  lowestFieldPositionInSectionBottomContent,
}: FieldHeaderProps) => {
  const [, , additionalConfigHasChanged] = useContext(
    AdditionalConfigStateContext,
  );
  const [nameEditing, setNameEditing] = useState(false);

  const editorIsReadonly = useContext(EditorIsReadonlyContext);

  if (nameEditing && !editorIsReadonly) {
    return (
      <HeaderWrapper shadeBackground>
        <FieldNameEditor onClose={() => setNameEditing(false)} />
      </HeaderWrapper>
    );
  }

  return (
    <HeaderWrapper>
      <FieldName onClick={() => setNameEditing(true)} />
      {additionalConfigHasChanged ? (
        <SaveAdditionalConfigChangesButton />
      ) : (
        <>
          <FieldPositionMoving
            allHighestPositions={allHighestPositions}
            lowestFieldPositionInSectionBottomContent={
              lowestFieldPositionInSectionBottomContent
            }
          />
          <FieldActions onNameEdit={() => setNameEditing(true)} />
        </>
      )}
    </HeaderWrapper>
  );
};

export default FieldHeader;
